module.exports = __webpack_public_path__ + "static/media/crewlist-icon-blue.abdaf27e.svg";